(function () {
  'use strict';


  /* -- EMAIL TYPO GUARD ------------------------------------
     The validity regex accepts ANY tld, so real people typing ".con" sailed
     straight through and hard-bounced forever: 4 of 296 quiz signups between
     2026-05-25 and 2026-08-18, i.e. 1.4% of all signups lost for want of a
     tld check. We SUGGEST a correction rather than reject, because a hard
     reject loses the signup just as surely. ".co" is a real tld, so it is only
     corrected for domains that provably have no .co variant (see DOMAIN_FIX). */
  var TLD_FIX = {
    con: 'com', cim: 'com', cpm: 'com', vom: 'com', xom: 'com', som: 'com',
    comm: 'com', cmo: 'com', ocm: 'com', copm: 'com', clm: 'com',
    nte: 'net', ner: 'net', bet: 'net', orgg: 'org', orh: 'org'
  };
  var DOMAIN_FIX = {
    'gmial.com': 'gmail.com', 'gmai.com': 'gmail.com', 'gnail.com': 'gmail.com',
    'gmaill.com': 'gmail.com', 'gmail.co': 'gmail.com', 'gamil.com': 'gmail.com',
    'yahooo.com': 'yahoo.com', 'yaho.com': 'yahoo.com', 'yahoo.co': 'yahoo.com',
    'hotmial.com': 'hotmail.com', 'hotmai.com': 'hotmail.com',
    'outlok.com': 'outlook.com', 'iclould.com': 'icloud.com', 'icloud.co': 'icloud.com'
  };
  function suggestEmail(email) {
    var at = email.lastIndexOf('@');
    if (at < 1) return null;
    var local = email.slice(0, at), domain = email.slice(at + 1).toLowerCase();
    if (DOMAIN_FIX[domain]) return local + '@' + DOMAIN_FIX[domain];
    var dot = domain.lastIndexOf('.');
    if (dot < 1) return null;
    var tld = domain.slice(dot + 1);
    if (TLD_FIX[tld]) return local + '@' + domain.slice(0, dot + 1) + TLD_FIX[tld];
    return null;
  }

  /* ── CONFIG ─────────────────────────────────────────────── */
  var CODE        = 'WELCOME10';
  var KEY_SESSION = 'pw_exit_v1';   // sessionStorage — once per session
  var KEY_QUIZ    = 'pw_quiz_v1_done';
  var MIN_WAIT_MS = 5000;           // don't fire within 5s of page load
  var MAX_ITEMS   = 3;

  /* ── GATES ───────────────────────────────────────────────── */
  if (sessionStorage.getItem(KEY_SESSION)) return;
  /* Account/self-service pages (Awtomic subscription portal lives at
     /tools/bundle-subscriptions). Someone updating a card or resuming a
     membership is not an abandoning shopper, so no exit offer here. */
  var _path = location.pathname;
  if (/^\/tools\//.test(_path) || /^\/account/.test(_path) || /^\/apps\/club/.test(_path)) return;   // Wine Club page, 2026-09-18

  var startTime = Date.now();
  var launched  = false;

  /* ── CART FETCH ─────────────────────────────────────────── */
  function fetchCart(cb) {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(cb)
      .catch(function () {});
  }

  /* ── LAUNCH ─────────────────────────────────────────────── */
  function tryLaunch() {
    if (launched) return;
    if (Date.now() - startTime < MIN_WAIT_MS) return;
    launched = true;
    sessionStorage.setItem(KEY_SESSION, '1');
    fetchCart(function (cart) {
      if (!cart || cart.item_count < 1) return;
      injectCSS();
      buildOverlay(cart);
    });
  }

  /* ── EXIT INTENT ────────────────────────────────────────── */
  function onMouseLeave(e) {
    if (e.clientY > 5) return;
    document.removeEventListener('mouseleave', onMouseLeave);
    tryLaunch();
  }

  function onVisibilityChange() {
    if (document.visibilityState !== 'hidden') return;
    document.removeEventListener('visibilitychange', onVisibilityChange);
    tryLaunch();
  }

  document.addEventListener('mouseleave', onMouseLeave);
  document.addEventListener('visibilitychange', onVisibilityChange);

  /* ── CSS ────────────────────────────────────────────────── */
  function injectCSS() {
    var s = document.createElement('style');
    s.textContent = [
      '#pw-exit-overlay{',
        'position:fixed;inset:0;z-index:99998;',
        'background:rgba(32, 32, 32,0.55);',
        'backdrop-filter:blur(4px);-webkit-backdrop-filter:blur(4px);',
        'display:flex;align-items:center;justify-content:center;',
        'opacity:0;transition:opacity .32s cubic-bezier(.23,1,.32,1);',
        'font-family:"Inter",-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;',
      '}',
      '#pw-exit-overlay.pw-on{opacity:1}',

      '#pw-exit-card{',
        'background:#fff;width:100%;max-width:440px;',
        'position:relative;border-radius:16px;overflow:hidden;',
        'box-shadow:0 24px 60px -18px rgba(32,32,32,.34),0 8px 22px -12px rgba(32,32,32,.18);',
        'transform:translateY(8px) scale(.96);transition:transform .34s cubic-bezier(.23,1,.32,1);',
      '}',
      '#pw-exit-overlay.pw-on #pw-exit-card{transform:none}',

      '#pw-exit-close{',
        'position:absolute;top:14px;right:14px;',
        'width:30px;height:30px;display:flex;align-items:center;justify-content:center;',
        'cursor:pointer;background:none;border:none;padding:0;',
        'font-size:20px;line-height:1;color:#bbb;transition:color .15s;z-index:2;',
      '}',
      '#pw-exit-close:hover{color:#333}',

      '.pe-logo{padding:22px 22px 0;display:block}',
      '.pe-logo img{height:22px;display:block}',

      '.pe-inner{padding:20px 22px 26px}',

      '.pe-head{font-size:22px;font-weight:500;color:#202020;line-height:1.3;margin:0 0 6px}',
      '.pe-sub{font-size:15px;color:#555;line-height:1.65;margin:0 0 16px}',

      '.pe-cart-label{font-size:12px;font-weight:600;letter-spacing:0;text-transform:none;',
        'color:#999;font-family:"Inter",-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;margin:0 0 8px}',

      '.pe-items{border:1.5px solid #e8e0d6;border-radius:12px;overflow:hidden;margin-bottom:18px}',
      '.pe-item{',
        'padding:10px 14px;font-size:14px;color:#333;line-height:1.4;',
        'border-bottom:1px solid #f0e8de;',
      '}',
      '.pe-item:last-child{border-bottom:none}',
      '.pe-item-more{padding:8px 14px;font-size:13px;color:#aaa;font-style:italic}',

      '.pe-textarea{',
        'width:100%;box-sizing:border-box;resize:none;',
        'border:1.5px solid #e8e0d6;border-radius:12px;padding:12px 14px;',
        'font-size:14px;font-family:inherit;color:#333;background:#fff;',
        'outline:none;transition:border-color .15s;margin-bottom:8px;display:block;',
        'line-height:1.5;',
      '}',
      '.pe-textarea:focus{border-color:#202020}',
      '.pe-textarea::placeholder{color:#ccc}',

      '.pe-email-input{',
        'width:100%;box-sizing:border-box;',
        'border:1.5px solid #e8e0d6;border-radius:12px;padding:11px 14px;',
        'font-size:14px;font-family:inherit;color:#333;background:#fff;',
        'outline:none;transition:border-color .15s;margin-bottom:10px;display:block;',
      '}',
      '.pe-email-input:focus{border-color:#202020}',
      '.pe-email-input::placeholder{color:#ccc}',

      '.pe-send{',
        'width:100%;background:#202020;color:#fff;border:none;border-radius:999px;',
        'padding:14px;font-size:15px;font-weight:600;font-family:inherit;',
        'cursor:pointer;transition:opacity .15s;margin-bottom:10px;display:block;',
      '}',
      '.pe-send:hover{opacity:.88}',
      '.pe-send:disabled{opacity:.45;cursor:not-allowed}',

      '.pe-sent{font-size:15px;color:#202020;font-weight:500;margin:0 0 6px;text-align:center}',
      '.pe-sent-sub{font-size:13px;color:#888;margin:0 0 14px;text-align:center;line-height:1.5}',

      '.pe-form-err{font-size:12px;color:#c0392b;margin:0 0 8px;display:none}',
      '.pe-form-err.on{display:block}',

      '.pe-divider{',
        'display:flex;align-items:center;gap:10px;',
        'margin:6px 0 14px;color:#ccc;font-size:12px;',
      '}',
      '.pe-divider::before,.pe-divider::after{content:"";flex:1;height:1px;background:#e8e0d6}',

      '.pe-code-label{font-size:14px;color:#555;margin:0 0 10px;line-height:1.5}',
      '.pe-codebox{',
        'display:flex;align-items:center;justify-content:space-between;',
        'border:1.5px dashed #202020;border-radius:12px;padding:11px 14px;margin-bottom:14px;',
      '}',
      '.pe-code{',
        'font-family:"Inter",-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;',
        'font-size:19px;letter-spacing:.15em;color:#202020;font-weight:600;',
      '}',
      '.pe-copy{',
        'font-size:12px;font-weight:600;color:#202020;',
        'background:none;border:1px solid #202020;border-radius:999px;padding:5px 11px;',
        'cursor:pointer;font-family:inherit;transition:background .15s,color .15s;',
      '}',
      '.pe-copy:hover{background:#202020;color:#fff}',

      '.pe-checkout{',
        'display:block;text-align:center;font-size:14px;color:#888;',
        'text-decoration:underline;text-underline-offset:3px;cursor:pointer;',
        'background:none;border:none;width:100%;font-family:inherit;padding:2px 0;',
      '}',
      '.pe-checkout:hover{color:#202020}',

      '@media(max-width:520px){',
        '#pw-exit-overlay{align-items:flex-end}',
        '#pw-exit-card{max-width:100%;border-radius:16px 16px 0 0;transform:translateY(20px)}',
        '.pe-head{font-size:20px}',
      '}',
      '@media(prefers-reduced-motion:reduce){',
        '#pw-exit-overlay,#pw-exit-card{transition:none}',
        '#pw-exit-card{transform:none}',
      '}'
    ].join('');
    document.head.appendChild(s);
  }

  /* ── BUILD ──────────────────────────────────────────────── */
  function buildOverlay(cart) {
    var isFirstTimer = !localStorage.getItem(KEY_QUIZ);
    var count        = cart.item_count;
    var items        = cart.items || [];

    var overlay = document.createElement('div');
    overlay.id  = 'pw-exit-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Before you go');

    var card = document.createElement('div');
    card.id  = 'pw-exit-card';

    var closeBtn = document.createElement('button');
    closeBtn.id   = 'pw-exit-close';
    closeBtn.type = 'button';
    closeBtn.setAttribute('aria-label', 'Close');
    closeBtn.innerHTML = '&times;';
    closeBtn.addEventListener('click', function () {
      overlay.classList.remove('pw-on');
      setTimeout(function () { if (overlay.parentNode) overlay.parentNode.removeChild(overlay); }, 300);
    });
    card.appendChild(closeBtn);

    var logoWrap = document.createElement('div');
    logoWrap.className = 'pe-logo';
    var logoImg = document.createElement('img');
    logoImg.src    = 'https://cdn.shopify.com/s/files/1/0019/3363/9735/files/primal-wine-logo-song-customized-final-202020.svg?v=1782858277';
    logoImg.alt    = 'Primal Wine';
    logoImg.height = 22;
    logoWrap.appendChild(logoImg);
    card.appendChild(logoWrap);

    var inner = document.createElement('div');
    inner.className = 'pe-inner';

    var head = document.createElement('p');
    head.className   = 'pe-head';
    head.textContent = 'Still thinking about it?';
    inner.appendChild(head);

    var sub = document.createElement('p');
    sub.className   = 'pe-sub';
    sub.textContent = 'You have ' + count + (count === 1 ? ' bottle' : ' bottles') + ' in your cart. Do you have a question about any of our wines?';
    inner.appendChild(sub);

    var cartLabel = document.createElement('p');
    cartLabel.className   = 'pe-cart-label';
    cartLabel.textContent = 'Your cart';
    inner.appendChild(cartLabel);

    var itemsEl = document.createElement('div');
    itemsEl.className = 'pe-items';

    var shown = Math.min(items.length, MAX_ITEMS);
    for (var i = 0; i < shown; i++) {
      var d = document.createElement('div');
      d.className = 'pe-item';
      var title = items[i].product_title || items[i].title || '';
      var qty   = items[i].quantity;
      d.textContent = (qty > 1 ? qty + ' × ' : '') + truncate(title, 48);
      itemsEl.appendChild(d);
    }
    if (items.length > MAX_ITEMS) {
      var more = document.createElement('div');
      more.className   = 'pe-item-more';
      more.textContent = '+ ' + (items.length - MAX_ITEMS) + ' more';
      itemsEl.appendChild(more);
    }
    inner.appendChild(itemsEl);

    // Inline question form
    var cartContext = items.slice(0, MAX_ITEMS).map(function (it) { return (it.product_title || it.title); }).join(', ');

    var textarea = document.createElement('textarea');
    textarea.className   = 'pe-textarea';
    textarea.rows        = 3;
    textarea.placeholder = 'What would you like to know?';
    inner.appendChild(textarea);

    var emailInput = document.createElement('input');
    emailInput.type        = 'email';
    emailInput.className   = 'pe-email-input';
    emailInput.placeholder = 'Your email (so Guido can reply)';
    emailInput.setAttribute('autocomplete', 'email');
    inner.appendChild(emailInput);

    var exitTypoOK = false;
    var formErr = document.createElement('p');
    formErr.className = 'pe-form-err';
    formErr.textContent = 'Please write your question and include your email.';
    inner.appendChild(formErr);

    var sendBtn = document.createElement('button');
    sendBtn.type      = 'button';
    sendBtn.className = 'pe-send';
    sendBtn.textContent = 'Send to Guido →';
    inner.appendChild(sendBtn);

    sendBtn.addEventListener('click', function () {
      var msg   = textarea.value.trim();
      var email = emailInput.value.trim();
      var _fix = email ? suggestEmail(email) : null;
      if (_fix && _fix !== email && !exitTypoOK) {
        emailInput.value = _fix;
        exitTypoOK = true;
        formErr.textContent = 'We corrected this to ' + _fix + '. Tap again to confirm.';
        formErr.classList.add('on');
        try { emailInput.focus(); } catch (e) {}
        return;
      }
      if (!msg || !email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        formErr.textContent = 'Please write your question and include your email.';
        formErr.classList.add('on');
        return;
      }
      formErr.classList.remove('on');
      sendBtn.disabled    = true;
      sendBtn.textContent = 'Sending…';

      var body = 'Question from: ' + email + '\nCart: ' + cartContext + '\n\n' + msg;
      var params = new URLSearchParams({
        'form_type':       'contact',
        'utf8':            '✓',
        'contact[email]':  email,
        'contact[body]':   body,
        'contact[name]':   email
      });

      fetch('/contact', {
        method:  'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body:    params.toString()
      }).then(function () {
        textarea.remove();
        emailInput.remove();
        formErr.remove();
        sendBtn.remove();

        var sent = document.createElement('p');
        sent.className   = 'pe-sent';
        sent.textContent = 'Sent! Guido will get back to you shortly.';

        var sentSub = document.createElement('p');
        sentSub.className   = 'pe-sent-sub';
        sentSub.textContent = 'In the meantime, your cart is saved.';

        var ref = inner.querySelector('.pe-divider') || inner.querySelector('.pe-checkout');
        inner.insertBefore(sentSub, ref);
        inner.insertBefore(sent, sentSub);
      }).catch(function () {
        sendBtn.disabled    = false;
        sendBtn.textContent = 'Send to Guido →';
        formErr.textContent = 'Something went wrong, please try again.';
        formErr.classList.add('on');
      });
    });

    // WELCOME10 — first-timers only
    if (isFirstTimer) {
      var divider = document.createElement('div');
      divider.className   = 'pe-divider';
      divider.textContent = 'First order?';
      inner.appendChild(divider);

      var codeLabel = document.createElement('p');
      codeLabel.className   = 'pe-code-label';
      codeLabel.textContent = 'Use this code at checkout for 10% off.';
      inner.appendChild(codeLabel);

      var codeBox = document.createElement('div');
      codeBox.className = 'pe-codebox';

      var codeVal = document.createElement('span');
      codeVal.className   = 'pe-code';
      codeVal.textContent = CODE;
      codeBox.appendChild(codeVal);

      var copyBtn = document.createElement('button');
      copyBtn.type      = 'button';
      copyBtn.className = 'pe-copy';
      copyBtn.textContent = 'Copy';
      copyBtn.addEventListener('click', function () {
        navigator.clipboard.writeText(CODE).then(function () {
          copyBtn.textContent = 'Copied!';
          setTimeout(function () { copyBtn.textContent = 'Copy'; }, 2000);
        });
      });
      codeBox.appendChild(copyBtn);
      inner.appendChild(codeBox);
    }

    var checkout = document.createElement('button');
    checkout.type      = 'button';
    checkout.className = 'pe-checkout';
    checkout.textContent = 'Continue to checkout';
    checkout.addEventListener('click', function () { window.location.href = '/checkout'; });
    inner.appendChild(checkout);

    card.appendChild(inner);
    overlay.appendChild(card);
    document.body.appendChild(overlay);

    requestAnimationFrame(function () {
      requestAnimationFrame(function () { overlay.classList.add('pw-on'); });
    });
  }

  /* ── HELPERS ────────────────────────────────────────────── */
  function truncate(str, n) { return str.length > n ? str.slice(0, n - 1) + '…' : str; }

})();
